<template>
    <div class="review-modal-mask">
      <div>
        <div class="review-modal-container">
          <div class="review-modal-header">
            <slot name="header">
              <div>
                <a class="review-modal-header product-review-back" @click="$emit('close')">
                  <span class="product-gallery-back-icon af af-chevron-left accent"></span>
                  <div class="review-modal-header accent product-review-back-icon">
                    Back<template v-if="product"> to {{ product.collection ? product.collection.name : product.title }}</template>
                  </div>
                </a>
                <button @click="$emit('close')" class="review-modal-header product-review-close button white filled icon" aria-label="Close customer review list">
                  <span class="af af-close"></span>
                </button>
              </div>
            </slot>
          </div>
          <div class="review-modal-body">
            <slot name="body">
              <div>
                <div class="review-modal-body review-summary">
                  <NewProductReviewSummary
                    :loading="loading"
                    :error="error"
                    :product="product"
                    :reviewUrl="reviewUrl"
                    :filter-star="filterStar"
                    :filter-tag="filterTag"
                    :available-tags="availableTags"
                    :review-count="reviewCount"
                    :show-actions="showActions"
                    @updateStars="$emit('updateStars', $event)"
                    @updateTags="$emit('updateTags', $event)"
                    @close="$emit('close')"
                  ></NewProductReviewSummary>
                  <button @click="$emit('close')" class="review-modal-body button white filled icon new-product-review-close">
                    <span class="af af-close"></span>
                  </button>
                </div>
                <div>
                  <template v-if="reviewsExactProduct && product">
                    <ProductReviewSection
                      v-for="review in reviewsExactProduct.slice(0, reviewsExactProduct.length)"
                      :key="review.id"
                      :review="review"
                      :product-title="product.title"
                      :show-product="true"
                      :show-featured="true"
                      :show-read-more="show"
                    ></ProductReviewSection>
                  </template>
                  <template v-if="(!countExactProduct || !count) && (!loading || reviews.length)">
                    <div v-if="product && product.review && !product.review.count" class="review-modal-body no-reviews">
                      <div v-if="isNewProduct">
                        This newer product is still making itself at home,<br/>
                        so you might get to write the first review. (Congrats!)
                      </div>
                      <template v-else>
                        <div>
                          Hmm, there aren’t any reviews yet<template v-if="product"> for the {{ product.title }}</template
                          >-
                        </div>
                        <div>which means you might get to write the first one. (Congrats!)</div>
                      </template>
                    </div>
                    <div v-else-if="error" class="review-modal-body no-reviews">
                      <div>Hmm, something went wrong while loading reviews. Please try again later.</div>
                    </div>
                    <div v-else class="review-modal-body no-reviews">No reviews match the selected filters.</div>
                  </template>
                  <template v-if="product && reviewsSimilarProduct && reviewsSimilarProduct.length">
                    <div class="review-modal-body similar-product-review-container">
                      <div class="review-modal-body similar-reviews-title">Reviews for similar products</div>
                      <ProductReviewSection
                        v-for="review in reviewsSimilarProduct"
                        :key="review.id"
                        :review="review"
                        :show-product="true"
                        :show-featured="true"
                      ></ProductReviewSection>
                    </div>
                  </template>
                </div>
              </div>
            </slot>
          </div>

          <div class="review-modal-footer">
            <slot name="footer">  
              <div v-if="reviewsSimilarProduct.length !== 0 || reviewsExactProduct.length !== 0" class="review-modal-footer review-button-section">
                <button v-if="(this.isMore && this.count)" class="read-review-button outlined coral review-button section-btn" @click.prevent="$emit('loadMore')" aria-label="Read more reviews">
                  Read More Reviews
                </button>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
import NewProductReview from '@/components/reviews/NewProductReview.vue';
import NewProductReviewSummary from '@/components/reviews/NewProductReviewSummary.vue';
import { Divider } from '@/pixel/index';
import ProductReviewSection from '@/components/reviews/ProductReviewSection.vue';

export default {
  name: 'NewModalReview',
  components: {
    NewProductReview,
    NewProductReviewSummary,
    Divider,
    ProductReviewSection,
  },
  emits: ['loadMore'],
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    filterStar: {
      type: String,
      default: 'ALL',
    },
    filterTag: {
      type: String,
      default: '',
    },
    isNewProduct: {
      type: Boolean,
      default: false,
    },
    availableTags: {
      type: Array,
      default: () => [],
    },
    reviewCount: {
      type: Number,
      default: 0,
    },
    enableSimilar: {
      type: Boolean,
    },
    countExactProduct: {
      type: Number,
    },
    reviewsExactProduct: {
      type: Array,
    },
    reviewsSimilarProduct: {
      type: Array,
    },
    reviews: {
      type: Array,
    },
    count: {
      type: Number,
    },
    showActions: {
      type: Boolean,
      default: false,
    },
    reviewUrl: {
      type: String,
      default: ''
    },
    isMore: {
      type:Boolean,
    },
  },
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';
@import '@/pixel/style/mixins';

.review-modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0px;
  left: 0px;
  width: 100%;
  right: 0px;
  background-color: var(--white);
  overflow: auto;
  transition: opacity 0.3s ease;
}

.review-modal-container {
  width: inherit;
  height: calc(100vh - 40px);
  margin: 0px auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  overflow-y: scroll;
  padding-top: var(--space-5);
  padding-bottom: var(--space-5);
  @mixin responsiveContainerPadding;
}

.review-modal-header {
  .product-review-back {
    display: flex;
    margin-top: var(--space-10);
    margin-bottom: var(--space-6);

    @media (max-width: calc($tablet-breakpoint - 1px)) {
      display: none;
    }
  }
  .product-review-back-icon {
    text-decoration: underline var(--coral);
    margin-left: var(--space-2);
  }

  .product-review-close {
    margin-left: auto;
    margin-top: -50px;
    align-self: center;
    margin-right: var(--space-0);
    border: 1px solid var(--grey-ultra-light) !important;
    @media (min-width: $extra-small-breakpoint) and (max-width: calc($tablet-breakpoint - 1px)) {
      display: none !important;
    }
  }
}

.review-modal-body {
  .review-summary {
    margin-top: var(--space-5);
    @media (min-width: $extra-small-breakpoint) and (max-width: calc($tablet-breakpoint - 1px)) {
      flex-direction: row;
      margin-top: var(--space-10);
    }
  }

  .new-product-review-close {
    top: var(--space-10);
    position: fixed;
    right: var(--space-5);
    overflow: hidden;
    z-index: 11;
    background: #ffffff;
    height: var(--space-10);
    border: 1px solid var(--grey-ultra-light) !important;
    @media (min-width: $tablet-breakpoint) {
      display: none !important;
    }
  }

  .no-reviews {
    margin-top: var(--space-10);
  }

  .similar-reviews-title {
    font-size: var(--font-size-16);
    line-height: 150%;
    align-items: center;
    margin-top: var(--space-10);
    color: var(--grey-medium);
    margin-bottom: -20px;
  }
}

.review-modal-footer {
  .review-button-section {
    margin-bottom: var(--space-10);
    margin-top: var(--space-10);
    @media (min-width: $extra-small-breakpoint) and (max-width: calc($tablet-breakpoint - 1px)){
      margin-top: var(--space-0);
    }
  }
  .review-button {
    @media (min-width: $extra-small-breakpoint) and (max-width: calc($tablet-breakpoint - 1px)) {
      width: calc(100vw - 40px);
      height: var(--space-10);
      margin-top: var(--space-10);
      margin-bottom: 80px;
    }
  }

  .section-btn {
    margin-bottom: 80px;
  }
}
</style>
